<template>
  <div class="article-keep-reading__wrapper">
    <section-title class="article-keep-reading__title">
      Keep Reading
    </section-title>

    <article-bullet-list :articles="articles" />
  </div>
</template>
<script>
import { PROP_TYPES, propValidator } from '@/utils/validators'
import SectionTitle from '../SectionTitle'
import ArticleBulletList from '../ArticleBulletList'

export default {
  name: 'SidebarKeepReading',
  components: { SectionTitle, ArticleBulletList },
  props: {
    articles: propValidator([PROP_TYPES.ARRAY])
  },
  mounted() {
    this.$emit('mounted')
  }
}
</script>
